var productName = 'calendar';// Export library
export * from './webpack.entry.js';
// File is symlinked with "grunt symlink" task
export * from './webpack.core.entry.wc.js';
// region WebComponents
export { default as TimelineBaseTag } from '../lib/Scheduler/customElements/TimelineBaseTag.js';
export { default as CalendarTag } from '../lib/Calendar/customElements/CalendarTag.js';
// endregion
